<script lang="ts">
	import { type Media } from "luxedo-data"
	import { MediaTile, openMediaPreview } from "luxedo-comps"
	import { DragController } from "../../../../stores/DragContext"
	import { type ContextMenuOptions, triggerContextMenuWithGenerator } from "context-menu"
	import { CTXOptions } from "../../../../modules/ctx-menu/ContextMenuOptions"

	interface Props {
		media: Media
	}

	let { media }: Props = $props()

	let dragging = $state(false)
	function onDragStart() {
		dragging = true
	}

	function onDragEnd() {
		dragging = false
	}

	const generateCtxMenuOpts = (): ContextMenuOptions => {
		return CTXOptions.Media.createOptions(media)
	}

	function onClick() {
		openMediaPreview(media, triggerContextMenuWithGenerator(generateCtxMenuOpts))
	}
</script>

<div>
	<MediaTile
		{media}
		onclick={onClick}
		oncontextmenu={triggerContextMenuWithGenerator(generateCtxMenuOpts)}
		ondragend={DragController.onDragEnd(onDragEnd)}
		ondragstart={DragController.onDragStart(media, onDragStart)}
		ontouchstart={DragController.onDragStart(media, onDragStart)}
		ontouchend={DragController.onDragEnd(onDragEnd)}
		ontouchcancel={DragController.onDragEnd(onDragEnd)}
		{dragging}
	/>
</div>

<style>
</style>
